import React from 'react'

// TODO: Determine what needs to be included in the footer

function Footer() {
    return (
        <div className='footer'>
            Contact Us<br />
            Facebook Link<br />
            Instagram Link<br />
            Footer . . .
        </div>
    )
}

export default Footer